import { styled } from "@mui/material";

export const ExpenseTypesWrapper = styled("div")`
  padding-left: ${(props) => props.theme.spacing(4)};
`;
